module.exports = __webpack_public_path__ + "static/a-family-of-titan-scholars-legacy-small-thumbnails-100x100-fb28b7b7d99acde64dbcd5badda072b3.jpg";